import {Form, Select} from 'antd';
import {t} from 'i18next';
import {useEffect} from 'react';
import {RULES} from '@/constants';
import {useLang} from '@/hooks';
import {useCommonStore} from '@/stores';

interface HobbiesProps {
  fieldName?: string;
  placeHolder?: string;
  label?: string;
  required?: boolean;
  multiple?: boolean;
}

const Hobbies = ({
                   fieldName = 'hobbies',
                   label = `${t('hobbies')} :`,
                   placeHolder = t('selectHobby'),
                   required = false,
                   multiple = false,
                 }: HobbiesProps) => {
  const {getHobbies, hobbies} = useCommonStore();
  const {isLTR} = useLang();

  const fetchHobbies = () => {
    if (!hobbies || hobbies?.length === 0) {
      getHobbies();
    }
  }

  useEffect(fetchHobbies, []);

  const options = hobbies?.map((hobby) => ({
    label: isLTR ? hobby?.nameEn : hobby?.nameAr,
    value: hobby.objectID,
  }));

  return (
    <Form.Item rules={required ? [RULES.required] : []} name={fieldName} label={label}>
      <Select
        mode={multiple ? 'multiple' : undefined}
        filterOption
        optionFilterProp='label'
        showSearch
        placeholder={placeHolder}
        getPopupContainer={(trigger) => trigger.parentNode}
        options={options}
      />
    </Form.Item>
  );
};

export default Hobbies;
